import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormArray } from '@angular/forms';
import { IEOtpremnicaDto } from '@kodit/core/data-api';
import { FormGroupTypeSafe } from 'angular-typesafe-reactive-forms-helper';
import { Subscription } from 'rxjs';
import { EotpremnicaFormService } from '../../otpremnice/eotpremnica-form.service';
import { stringIsNullOrEmpty } from '@kodit/core/shared';

@Component({
  selector: 'kodit-opasne-materije-table',
  templateUrl: './opasne-materije-table.component.html',
  styleUrls: ['./opasne-materije-table.component.scss']
})
export class OpasneMaterijeTableComponent implements OnInit, OnDestroy {

  private _subs: Subscription = new Subscription();

  brojPocetnihStavki = 0;
  opasneMaterijeOtpremnice: FormArray;

  /** I/O */
  @Input() otpremnicaForm: FormGroupTypeSafe<IEOtpremnicaDto>;

  constructor(
    private _formService: EotpremnicaFormService,
  ) { }

  ngOnInit(): void {
    this.opasneMaterijeOtpremnice = this._formService.getOpasneMaterijeArray;
    if(this.opasneMaterijeOtpremnice.length == 0)
    {
      this.brojPocetnihStavki = this.opasneMaterijeOtpremnice.value.length;
      this.addEmptyMaterija();
    }
  }

  addEmptyMaterija(): void {
     for (let s of this.opasneMaterijeOtpremnice.controls) {
      if (stringIsNullOrEmpty(s.value.naziv)) {
        return;
      }
    }
    const idx = this.opasneMaterijeOtpremnice.length;
    this.opasneMaterijeOtpremnice.push(
      this._formService.getOpasnaMaterijaFormGroup()
    );
  }

    deleteStavka(rowIndex: number): void {
      this.opasneMaterijeOtpremnice.removeAt(rowIndex);
    }

  ngOnDestroy() {
    this._subs.unsubscribe();
  }

}
